import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "../redux/initialState"
import { AdminManagementListMeta, adminManagementTableRow, newUserForm, statusFilter, userDetailes } from "../types/index"

export const sliceKey = "adminMangmentState"

type AdminManagementListSuccessPayload = {
  data: adminManagementTableRow[];
  meta: AdminManagementListMeta;
};

export const adminManagementSlice = createSlice({
  name: sliceKey,
  initialState: initialState,
  reducers: {

      setStatusFilter: (state, action: PayloadAction<statusFilter>) => {
        state.statusFilter = action.payload
      },

      getUserList: (state) => {
        state.isLoading = true;
        state.error = null;
        state.page = 1;
      },

      getUserListSucsess: (state, action: PayloadAction<AdminManagementListSuccessPayload>) => {
        state.data = action.payload.data;
        state.meta = action.payload.meta;
        state.page = action.payload.meta.currentPage;
        state.isLoading = false;
        state.error = null;
      },

      getUserListFailier: (state, action: PayloadAction<string>) => {
        state.isLoading = false;
        state.error = action.payload;
      },

      getNextPageItems: (state) => {
        if (state.isLoading || state.meta.currentPage >= state.meta.totalPages) {
          return;
        }
        state.isLoading = true;
        state.error = null;
        state.page = state.meta.currentPage + 1;
      },

      getNextPageItemsSuccess: (state, action: PayloadAction<AdminManagementListSuccessPayload>) => {
        state.data = state.data.concat(action.payload.data);
        state.meta = action.payload.meta;
        state.page = action.payload.meta.currentPage;
        state.isLoading = false;
        state.error = null;
      },

      getNextPageItemsFailure: (state, action: PayloadAction<string>) => {
        state.isLoading = false;
        state.error = action.payload;
      },

      addNewUser: (state, action: PayloadAction<newUserForm>) => {
        state.isLoading = true
        state.newUserForm = action.payload
      },

      addUserListSucsess: (state, action: PayloadAction<adminManagementTableRow>) => {
        state.data.push(action.payload)
        state.isLoading = false
        state.newUserForm = initialState.newUserForm
      },

      addUserListFailier: (state) => {
        state.isLoading = false
        state.newUserForm = initialState.newUserForm

      },

      setFormField: (state, action: PayloadAction<{ name: keyof newUserForm; value: string }>) => {
        state.newUserForm = { ...state.newUserForm, [action.payload.name]: action.payload.value }
      },

      resetForm: (state) => {
        state.newUserForm = { fullName: "", email: "", role: "", mobileNumber: "", department: "" }
      },

      openAddModal: (state) => {
        state.isAddModalOpen = true
      },

      closeAddModal: (state) => {
        state.isAddModalOpen = false
      },

      getUserDetailes: (state, action: PayloadAction<string>) => {
        state.isLoading = true;
        state.error = null;
        state.userDetailes = null;
      },

      getUserDetailesSucsess: (state, action: PayloadAction<userDetailes>) => {
        state.isLoading = false;
        state.userDetailes = action.payload;
      },

      getUserDetailesFailier: (state, action: PayloadAction<string>) => {
        state.isLoading = false;
        state.error = action.payload;
      },
  }
});

export const { reducer, actions } = adminManagementSlice
